const LS_LABEL = 'details-visibility'

const useSubfilterActions = ({
  filterData,
  setFilterData,
  fieldName,
  operand,
  type
}) => {
  const onToggleDetails = () => {
    const currentState = localStorage.getItem(`${type}-${LS_LABEL}`)
    if (!currentState || currentState === 'closed') {
      localStorage.setItem(`${type}-${LS_LABEL}`, 'opened')
    } else {
      localStorage.setItem(`${type}-${LS_LABEL}`, 'closed')
    }
  }

  const checkIsEnabled = (data) => {
    const computedData = data?._id || data?.value

    return filterData?.where?.some((query) => query?.includes(computedData))
  }

  const ifFilterDataHasAnyCategory = (fieldName) =>
    filterData?.where
      ? filterData?.where?.findIndex((query) => query?.includes(fieldName))
      : -1

  const onChange = (data, isSame) => {
    const computedData = data._id || data?.value
    const computedOperand = data?.operand || operand
    const computedFieldName = data?.fieldName || fieldName

    if (checkIsEnabled(data)) {
      setFilterData((prev) => {
        return {
          where: [
            ...prev.where.filter((query) => !query.includes(computedData))
          ]
        }
      })
    } else {
      const index = ifFilterDataHasAnyCategory(computedFieldName, isSame)
      setFilterData((prev) => {
        const newFilterData = { ...prev }

        if (index === -1) {
          newFilterData.where = !Array.isArray(newFilterData.where)
            ? [[computedFieldName, computedOperand, computedData]]
            : [
                ...newFilterData.where,
                [computedFieldName, computedOperand, computedData]
              ]
        } else {
          newFilterData.where[index] = [
            ...[computedFieldName, computedOperand, computedData]
          ]
        }
        return JSON.parse(JSON.stringify({ ...newFilterData }))
      })
    }
  }

  return { onChange, checkIsEnabled, onToggleDetails }
}

export default useSubfilterActions
